<template>
  <component :is="layout" v-if="!onRefresh" v-bind="props" />
</template>

<script>
  export default {
    name: 'Layout',

    provide() {
      return {
        Layout: this
      }
    },

    components: {
      // 支持的布局组件
      user: () => import('./User.vue'), // 用户默认布局
      admin: () => import('./Admin.vue'), // 管理员默认布局
      upgrade: () => import('./Admin-upgrade.vue'), // 管理员+版本升级页面
      empty: () => import('./Empty.vue') // 空路由
    },

    props: {
      // 默认布局
      default: {
        type: String,
        default: 'user'
      }
    },

    data() {
      return {
        onRefresh: false
      }
    },

    computed: {
      // 匹配最末端的 layout 配置
      matchRoute() {
        const layoutRoutes = this.$route.matched.filter(({ meta }) => meta && meta.layout)
        return layoutRoutes[layoutRoutes.length - 1]
      },

      // 布局相关配置
      config() {
        const { matchRoute } = this
        const config = (matchRoute && matchRoute.meta.layout) || {}

        return this.parseConfig(config)
      },

      // 当前布局
      layout() {
        const config = this.matchConfig

        return this.config.layout || this.default
      },

      // 布局参数
      props() {
        return this.config.props
      }
    },

    methods: {
      // 解析配置
      parseConfig(config) {
        let layout
        let props

        switch (typeof config) {
          case 'string':
            layout = config
            break
          case 'object':
            layout = config.name
            props = { ...config }
            delete props.name
            break
          case 'function':
            return this.parseConfig(config(this.$route))
        }

        return {
          layout,
          props
        }
      },

      // 强制刷新页面
      async refresh() {
        this.onRefresh = true

        await this.$nextTick()

        this.onRefresh = false
      }
    }
  }
</script>
